import React from 'react';
import usePdfDataLoader from './usePdfDataLoader';

type PdfData = ReturnType<typeof usePdfDataLoader>;

export const PdfDataContext = React.createContext<PdfData>(null);
